import type { HTMLAttributes, ReactNode } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const badge = cva(
  [
    "inline-flex items-center gap-1 rounded-[var(--radius-sm)]",
    "px-1.5 h-5 text-[11px] font-medium tracking-wide",
    "[&_svg]:size-3 [&_svg]:shrink-0",
  ],
  {
    variants: {
      tone: {
        neutral: "bg-muted text-fg-muted",
        accent:  "bg-accent-subtle text-accent-text",
        success: "bg-success-bg text-success-fg",
        warning: "bg-warning-bg text-warning-fg",
        danger:  "bg-danger-bg text-danger-fg",
        info:    "bg-info-bg text-info-fg",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badge> {
  icon?: ReactNode;
}

export function Badge({ tone, icon, className, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badge({ tone }), className)} {...props}>
      {icon}
      {children}
    </span>
  );
}
